module.exports = __webpack_public_path__ + "static/media/IMG_1901-min.5a526f25.jpg";